/** Deep-link target for opening a panorama at a saved PSV view. */
export interface OpenPanorama {
  id: string;
  yaw: number;
  pitch: number;
  zoom: number;
}

/** Read a finite number from search params, or fall back to 0. */
function num(params: URLSearchParams, key: string): number {
  const n = Number(params.get(key));
  return Number.isFinite(n) ? n : 0;
}

/**
 * Parse `?pano=<id>&yaw=<rad>&pitch=<rad>&zoom=<n>` into an OpenPanorama, or
 * undefined when there is no `pano` param.
 */
export function parseOpenPanorama(params: URLSearchParams): OpenPanorama | undefined {
  const id = params.get("pano");
  if (id === null || id === "") return undefined;
  return {
    id,
    yaw: num(params, "yaw"),
    pitch: num(params, "pitch"),
    zoom: num(params, "zoom"),
  };
}
